<template>
  <b-form @submit.prevent="submit">
    <b-row class="mb-3">
      <b-col lg="6">
        <b-form-group label="Descripción">
          <b-form-input v-model="descuento.descripcion" required type="text" placeholder="Descripción del descuento" />
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label="Descuento %">
          <b-form-input required type="number" v-model="descuento.descuento" placeholder="Descuento" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-card header="Configuración">
      <b-card-body>
        <b-form-group>
          <b-form-checkbox switch size="lg" v-model="descuento.estado"> Activo </b-form-checkbox>
          <b-form-checkbox switch size="lg" v-model="descuento.usablePorResponsable">
            Permitido para responsable
          </b-form-checkbox>
          <b-form-checkbox switch size="lg" v-model="descuento.usablePorComercial">
            Permitido para comercial
          </b-form-checkbox>
          <b-form-checkbox switch size="lg" v-model="descuento.paraCuota"> Aplicable a cuota </b-form-checkbox>
          <b-form-checkbox switch size="lg" v-model="descuento.paraServicios"> Aplicable a servicios </b-form-checkbox>
        </b-form-group>
      </b-card-body>
    </b-card>

    <botonera-edicion url-cancelar="/descuentos" />
  </b-form>
</template>
<script>
export default {
  props: {
    descuento: Object,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    "$route.params": {
      handler: function () {},
      deep: true,
      immediate: true,
    },
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
  },
};
</script>
